<template>
  <GalleryDashboardCardUI
    :event-name="eventName"
    :event-date="eventDate"
    :images="images"
    :all-images-count="allImagesCount"
    :user-image-src="userImageSrc"
    :user-name="userName"
    :post-date="postDate"
    :show-level-icon="showLevelIcon"
    :gallery-url="galleryUrl"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import GalleryDashboardCardUI, {
  GalleryImage,
} from "features/gallery/dashboard/GalleryDashboardCardUI.vue"
import { EventGallery } from "suus-api"
import {
  getContextNameLong,
  getViewContextOfGroup,
  ViewContext,
} from "concerns/useContextName"

export default defineComponent({
  name: "GalleryDashboardCard",
  components: {
    GalleryDashboardCardUI,
  },
  props: {
    eventGallery: {
      type: Object as PropType<EventGallery>,
      required: true,
    },
  },
  setup(props) {
    const eventGallery = props.eventGallery
    const group = eventGallery.event.group

    const viewContext: ViewContext = getViewContextOfGroup(group)

    const eventName = eventGallery.event.title
    const eventDate = new Date(eventGallery.event.start_date)

    const images: GalleryImage[] = eventGallery.event_media_preview.map(
      (media) => ({
        src: media.uploaded_file.thumb.url,
      })
    )
    const allImagesCount = eventGallery.event_media_count
    const userImageSrc = eventGallery.creator.avatar_url
    const userName = getContextNameLong(viewContext, eventGallery.creator)
    const postDate = new Date(eventGallery.created_at)
    const showLevelIcon = !!group.level_id

    const galleryUrl = eventGallery.links.gallery_url

    return {
      eventName,
      eventDate,
      images,
      allImagesCount,
      userImageSrc,
      userName,
      postDate,
      showLevelIcon,
      galleryUrl,
    }
  },
})
</script>
